import { themeAtom } from "../../../shared/atoms";
import { adminStyles } from "../../styles/admin.styles";
import { ChevronLeftIcon, ChevronRightIcon } from "@heroicons/react/24/outline";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

type Props = {
  isCollapsed: boolean;
  onToggle: () => void;
};

const AdminSidebarHeading = ({ isCollapsed, onToggle }: Props) => {
  const theme = useAtomValue(themeAtom);

  return (
    <div className={twMerge(adminStyles.sidebar.sectionHeader, isCollapsed && "px-0 text-center")}>
      <div className={twMerge("flex items-start", isCollapsed ? "justify-center" : "justify-between gap-3")}>
        {!isCollapsed && (
          <div data-test="admin-sidebar-heading">
            <p className={twMerge("text-xs font-semibold uppercase", theme.headerComponent.inline.generalText)}>
              Admin
            </p>
            <h1 data-test="admin-sidebar-brand" className="mt-1 text-lg font-semibold">
              OpsLink
            </h1>
          </div>
        )}

        <button
          type="button"
          aria-label={isCollapsed ? "Expand admin sidebar" : "Collapse admin sidebar"}
          data-test="admin-sidebar-collapse-toggle"
          className="flex h-9 w-9 flex-shrink-0 items-center justify-center text-green transition-colors hover:bg-primary-10"
          onClick={onToggle}
        >
          {isCollapsed ? <ChevronRightIcon className="h-5 w-5" /> : <ChevronLeftIcon className="h-5 w-5" />}
        </button>
      </div>
    </div>
  );
};

export default AdminSidebarHeading;
